import { eventsSender } from 'globalState/global-state.js';

export const headerPhoneCall = () => {
    try {
        eventsSender('header', 'phoneCall');
        ym(17186719, 'reachGoal', 'phone_click');
    } catch (err) {
        console.error(err);
    }
};

export const headerWhatsappCall = () => {
    try {
        eventsSender('header', 'whatsappCall');
    } catch (err) {
        console.error(err);
    }
};
